import categorySlugsEN from '../../algolia-category-slugs-en.json';
import categorySlugsFR from '../../algolia-category-slugs-fr.json';
import { capitalize } from '@utils/plp/utils/transforms';

export const getCategoryNameFromSlug = (
  slug: string,
  locale = 'en'
): string => {
  const slugDict: { [key: string]: string | undefined } =
    locale === 'en' ? categorySlugsEN : categorySlugsFR;
  return slugDict[slug] || slug;
};
